module.exports = __webpack_public_path__ + "media/about/AboutUs-OurStory-1-11085e0d.png";